// | ------------------------------------------------------------------------
// | Bootstrap - Modals
// | ------------------------------------------------------------------------ 

import { Modal } from "bootstrap";
import ClassWatcher from '../classes/classWatcher';

// | ------------------------------------------------------------------------ 


// If mobile navigation is open then close all modals

function hideModals(){

    if(document.querySelectorAll('.modal.show').length > 0){
        var modals = document.querySelectorAll('.modal.show');
        modals.forEach(function(e){
            var modal = Modal.getInstance(e)                
            modal.hide();
        });           
    }  

}

let modalWatcher = new ClassWatcher(document.body, 'mobile-nav-open', hideModals, () => null);
